import styled, { css } from 'styled-components';
import * as fonts from 'view/styles/fonts';
import * as grid from 'view/styles/grid';
import * as mixins from 'view/styles/mixins';
import { GROUP_BOX_PADDING_LEFT_RIGHT } from '../group-box';
import { token } from '@atlaskit/tokens';

interface ListProps {
    offsetMargin?: boolean;
    withMargin?: boolean;
}

const GROUP_BOX_LIST_TOP_MARGIN = grid.multiple(2).px;

export const List = styled.ul<ListProps>`
    /* stylelint-disable-next-line scale-unlimited/declaration-strict-value */
    margin: ${(props) =>
        props.offsetMargin ? `-${GROUP_BOX_LIST_TOP_MARGIN} -${GROUP_BOX_PADDING_LEFT_RIGHT} 0` : '0'};
    padding: 0;
`;

export const ListItem = styled.li<ListProps>`
    display: block;
    ${(props) =>
        mixins.applyIf(
            !!props.withMargin,
            css`
                &:not(:last-child) {
                    margin-bottom: ${token('space.400', '32px')};
                }
            `
        )};
`;

export const SelectHeader = styled.h2`
    ${fonts.h500};
    display: block;
    margin-bottom: ${token('space.200', '16px')};
`;

export const SmallSelectHeader = styled(SelectHeader)`
    ${fonts.h200};
    margin-bottom: ${token('space.050', '4px')};
`;

export const LabelWithIcon = styled.label`
    display: flex;
    align-items: center;

    /* Apply a margin-right to every child that isn't the last. */
    /* We use this selector because it's nice and generic, so we don't have */
    /* to wrap a child with a container which would break flex centering. */
    > :not(:last-child) {
        margin-right: ${token('space.100', '8px')};
    }
`;

export const SimpleSelectOption = styled.div`
    margin-left: ${token('space.100', '8px')};
`;
